export enum ModalType {
  FORM_MODAL = 'form',
  LIST_MODAL = 'list',
  // Add more modal types as needed
}

export enum ModalType {
  Primary = 'primary',
  Warning = 'warning',
  Info = 'info',
  Danger = 'danger',
}



// WEBPACK FOOTER //
// ./src/app/components/modals/modal.const.ts